<template>
  <PersonalLayout>
    <template v-slot:header>
      <AppHeader />
    </template>
    <template v-slot:side>
      <router-link to="/my-objects" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M20 7L12 3L4 7M20 7L12 11M20 7V17L12 21M12 11L4 7M12 11V21M4 7V17L12 21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
         <span>{{ $t('nav.objects') }}</span>
      </router-link>
      <div class="side-slide active">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M4 7V4H20V7M9 20H15M12 4V20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
         <span>{{ $t('nav.fonts') }}</span>
      </div>
      <router-link to="/my-processings" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
         <span>{{ $t('nav.processing') }}</span>
      </router-link>
      <router-link to="/personal-subscription" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M21 4H3C1.89543 4 1 4.89543 1 6V18C1 19.1046 1.89543 20 3 20H21C22.1046 20 23 19.1046 23 18V6C23 4.89543 22.1046 4 21 4Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M1 10H23" stroke="currentColor" stroke-width="2"/></svg>
         <span>{{ $t('nav.subscription') }}</span>
      </router-link>
      <router-link to="/personal-account" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
         <span>{{ $t('common.account') }}</span>
      </router-link>
      <router-link to="/personal-security" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
         <span>{{ $t('nav.security') }}</span>
      </router-link>
      <router-link v-if="isAdmin" to="/admin" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 15C15.866 15 19 11.866 19 8C19 4.13401 15.866 1 12 1C8.13401 1 5 4.13401 5 8C5 11.866 8.13401 15 12 15Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.21 13.89L7 23L12 20L17 23L15.79 13.88" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
         <span>{{ $t('nav.admin') }}</span>
      </router-link>
      <div class="side-slide logout-slide" @click="handleLogout">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><polyline points="16,17 21,12 16,7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
         <span>{{ $t('common.logout') }}</span>
      </div>
    </template>
    <template v-slot:content>
      <div class="content-block">
        <div class="fonts-header">
           <h1>{{ $t('account.fontsTitle') }}</h1>
           <p class="fonts-description">{{ $t('legacy.Загрузите свои шрифты для использования в текстовых слоях') }}</p>
        </div>
      </div>

      <div v-if="!canUploadFonts" class="premium-required">
        <div class="premium-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </div>
         <h2>{{ $t('account.subscriptionRequired') }}</h2>
         <p>{{ $t('account.paidFontsOnly') }}</p>
         <router-link to="/personal-subscription" class="upgrade-btn">{{ $t('account.goToSubscription') }}</router-link>
      </div>

      <template v-else>
        <div class="upload-section">
           <h2>{{ $t('account.uploadFont') }}</h2>
          <div class="upload-form">
            <div class="form-group">
              <label>{{ $t('account.fontName') }}</label>
              <input 
                type="text" 
                v-model="newFont.name" 
                :placeholder="$t('legacy.Например: Roboto Bold')"
                class="form-input"
              />
            </div>
            <div class="form-group">
              <label>{{ $t('legacy.Файл шрифта (TTF, OTF, WOFF, WOFF2)') }}</label>
              <div class="file-input-wrapper">
                <input 
                  type="file" 
                  ref="fontFileInput"
                  @change="handleFileSelect"
                  accept=".ttf,.otf,.woff,.woff2"
                  class="file-input"
                />
                <div class="file-input-display" @click="$refs.fontFileInput.click()">
                  <span v-if="newFont.file">{{ newFont.file.name }}</span>
                   <span v-else class="placeholder">{{ $t('legacy.Выберите файл') }}</span>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><polyline points="17,8 12,3 7,8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><line x1="12" y1="3" x2="12" y2="15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                </div>
              </div>
            </div>
            <div class="form-group checkbox-group">
              <label class="checkbox-label">
                <input type="checkbox" v-model="newFont.licenseAgreed" />
                <span class="checkmark"></span>
                <span class="checkbox-text">
                  Я подтверждаю, что имею права на использование данного шрифта и понимаю, 
                  что платформа не несёт ответственности за нарушение лицензий на шрифты.
                </span>
              </label>
            </div>
            <button 
              class="upload-btn" 
              @click="uploadFont" 
              :disabled="!canUpload || uploading"
            >
               {{ uploading ? $t('common.loading') : $t('account.uploadFont') }}
            </button>
            <p v-if="uploadError" class="error-message">{{ uploadError }}</p>
             <p class="upload-hint">{{ $t('legacy.dynamic.fontsLimit', { maxFonts }) }}</p>
          </div>
        </div>

        <div class="fonts-section">
           <h2>{{ $t('legacy.dynamic.fontsUploaded', { count: fonts.length, maxFonts }) }}</h2>
          
          <div v-if="loading" class="loading-state">
             <p>{{ $t('legacy.dynamic.fontsLoading') }}</p>
          </div>
          
          <div v-else-if="fonts.length === 0" class="empty-state">
             <p>{{ $t('legacy.dynamic.fontsEmpty') }}</p>
          </div>
          
          <div v-else class="fonts-grid">
            <div v-for="font in fonts" :key="font.id" class="font-card">
              <div class="font-preview" :style="{ fontFamily: font.font_family }">
                 {{ $t('legacy.fontSample') }}
              </div>
              <div class="font-info">
                <span class="font-name">{{ font.font_name }}</span>
                <span class="font-size">{{ formatFileSize(font.file_size) }}</span>
              </div>
              <button class="delete-btn" @click="deleteFont(font)" :disabled="deleting === font.id">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M3 6H5H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </button>
            </div>
          </div>
        </div>
      </template>
    </template>
  </PersonalLayout>
</template>

<script>
import PersonalLayout from '@/layout/PersonalLayout.vue';
import AppHeader from '@/components/AppHeader.vue';
import { getUserFonts, uploadUserFont, deleteUserFont } from '@/api/userFonts';
import { useStore } from 'vuex';
import { computed, ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useToast } from 'vue-toastification';
import { t } from '@/i18n';

export default {
  name: 'PersonalFonts',
  components: {
    PersonalLayout,
    AppHeader
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const toast = useToast();
    
    const fonts = ref([]);
    const loading = ref(true);
    const uploading = ref(false);
    const deleting = ref(null);
    const uploadError = ref('');
    const maxFonts = 10;
    
    const newFont = ref({
      name: '',
      file: null,
      licenseAgreed: false
    });
    
    const fontFileInput = ref(null);
    
    const user = computed(() => store.state.auth.user);
    const isAdmin = computed(() => user.value?.role === 'admin');
    
    const canUploadFonts = computed(() => store.getters['subscription/canUploadFonts']);
    
    const canUpload = computed(() => {
      return canUploadFonts.value && newFont.value.name.trim() &&
             newFont.value.file && 
             newFont.value.licenseAgreed &&
             fonts.value.length < maxFonts;
    });
    
    const loadFonts = async () => {
      if (!canUploadFonts.value) {
        loading.value = false;
        return;
      }
      
      try {
        loading.value = true;
        const response = await getUserFonts();
        fonts.value = response.success && response.fonts ? response.fonts : [];
        loadFontFaces();
      } catch (error) {
        console.error('Error loading fonts:', error);
         toast.error(t('errors.loadFonts'));
      } finally {
        loading.value = false;
      }
    };
    
    const loadFontFaces = () => {
      fonts.value.forEach(font => {
        const fontFace = new FontFace(font.font_family, `url(/api/user-fonts/file/${font.file_path.split('/').pop()})`);
        fontFace.load().then(loadedFace => {
          document.fonts.add(loadedFace);
        }).catch(err => {
          console.error('Error loading font face:', err);
        });
      });
    };
    
    const handleFileSelect = (event) => {
      const file = event.target.files[0];
      if (file) {
        const ext = file.name.split('.').pop().toLowerCase();
        if (!['ttf', 'otf', 'woff', 'woff2'].includes(ext)) {
           uploadError.value = t('legacy.Поддерживаются только форматы TTF, OTF, WOFF, WOFF2');
          return;
        }
        if (file.size > 5 * 1024 * 1024) {
           uploadError.value = t('legacy.Размер файла не должен превышать 5 МБ');
          return;
        }
        newFont.value.file = file;
        uploadError.value = '';
      }
    };
    
    const uploadFont = async () => {
      if (!canUpload.value) return;
      
      try {
        uploading.value = true;
        uploadError.value = '';
        
        const result = await uploadUserFont(
          newFont.value.file,
          newFont.value.name.trim(),
          newFont.value.licenseAgreed
        );
        
        if (result.success) {
           toast.success(t('legacy.Шрифт успешно загружен'));
          newFont.value = { name: '', file: null, licenseAgreed: false };
          if (fontFileInput.value) {
            fontFileInput.value.value = '';
          }
          await loadFonts();
        }
      } catch (error) {
        console.error('Error uploading font:', error);
         uploadError.value = error.response?.data?.message || t('errors.loadFont');
        toast.error(uploadError.value);
      } finally {
        uploading.value = false;
      }
    };
    
    const deleteFont = async (font) => {
       if (!confirm(t('legacy.dynamic.fontDelete', { fontName: font.font_name }))) return;
      
      try {
        deleting.value = font.id;
        await deleteUserFont(font.id);
         toast.success(t('legacy.Шрифт удалён'));
        await loadFonts();
      } catch (error) {
        console.error('Error deleting font:', error);
         toast.error(t('errors.delete'));
      } finally {
        deleting.value = null;
      }
    };
    
    const formatFileSize = (bytes) => {
       if (bytes < 1024) return bytes + ` ${t('legacy.Б')}`;
       if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ` ${t('legacy.КБ')}`;
       return (bytes / (1024 * 1024)).toFixed(1) + ` ${t('legacy.МБ')}`;
    };
    
    const handleLogout = async () => {
      await store.dispatch('auth/logout');
      router.push('/');
    };
    
    onMounted(async () => {
      await store.dispatch('subscription/init');
      loadFonts();
    });
    
    return {
      fonts,
      loading,
      uploading,
      deleting,
      uploadError,
      maxFonts,
      newFont,
      fontFileInput,
      user,
      isAdmin,
      canUploadFonts,
      canUpload,
      handleFileSelect,
      uploadFont,
      deleteFont,
      formatFileSize,
      handleLogout
    };
  }
};
</script>

<style scoped>
.content-block {
  background: white;
  border-radius: 10px;
  padding: 20px 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}

.fonts-header h1 {
  font-size: 24px;
  color: #26374e;
  margin: 0 0 8px;
}

.fonts-description {
  color: #6b7280;
  margin: 0;
}

.premium-required {
  background: white;
  border-radius: 10px;
  padding: 40px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.premium-icon {
  color: #f59e0b;
  margin-bottom: 16px;
}

.premium-required h2 {
  color: #26374e;
  margin: 0 0 8px;
}

.premium-required p {
  color: #6b7280;
  margin: 0 0 24px;
}

.upgrade-btn {
  display: inline-block;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 500;
  transition: transform 0.2s, box-shadow 0.2s;
}

.upgrade-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.upload-section, .fonts-section {
  background: white;
  border-radius: 10px;
  padding: 20px 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
}

.upload-section h2, .fonts-section h2 {
  font-size: 18px;
  color: #26374e;
  margin: 0 0 20px;
}

.upload-form {
  max-width: 500px;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  font-size: 14px;
  color: #374151;
  margin-bottom: 6px;
}

.form-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.form-input:focus {
  outline: none;
  border-color: #667eea;
}

.file-input-wrapper {
  position: relative;
}

.file-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.file-input-display {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border: 1px dashed #d1d5db;
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;
}

.file-input-display:hover {
  border-color: #667eea;
  background-color: #f9fafb;
}

.file-input-display .placeholder {
  color: #9ca3af;
}

.checkbox-group {
  margin-top: 20px;
}

.checkbox-label {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  margin-top: 2px;
  flex-shrink: 0;
}

.checkbox-text {
  font-size: 13px;
  color: #4b5563;
  line-height: 1.5;
}

.upload-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s;
  margin-top: 8px;
}

.upload-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.upload-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.error-message {
  color: #dc2626;
  font-size: 13px;
  margin: 10px 0 0;
}

.upload-hint {
  color: #9ca3af;
  font-size: 12px;
  margin: 10px 0 0;
}

.loading-state, .empty-state {
  text-align: center;
  padding: 40px;
  color: #6b7280;
}

.fonts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
}

.font-card {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  position: relative;
}

.font-preview {
  font-size: 24px;
  color: #26374e;
  margin-bottom: 12px;
  min-height: 36px;
}

.font-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.font-name {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
}

.font-size {
  font-size: 12px;
  color: #9ca3af;
}

.delete-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background: none;
  border: none;
  padding: 6px;
  cursor: pointer;
  color: #9ca3af;
  border-radius: 4px;
  transition: color 0.2s, background-color 0.2s;
}

.delete-btn:hover {
  color: #dc2626;
  background-color: #fee2e2;
}

.delete-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.side-slide {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  color: #6b7280;
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.2s;
  cursor: pointer;
}

.side-slide:hover {
  background: #f3f4f6;
  color: #374151;
}

.side-slide.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.logout-slide:hover {
  background: #fee2e2;
  color: #dc2626;
}

@media (max-width: 768px) {
  .content-block, .upload-section, .fonts-section {
    padding: 15px;
    margin-bottom: 15px;
  }

  .fonts-header h1 {
    font-size: 20px;
  }

  .fonts-grid {
    grid-template-columns: 1fr;
  }

  .upload-form {
    max-width: 100%;
  }
}
</style>
